import React, { useReducer, useRef } from 'react';
import { createPortal } from 'react-dom';
import { ModalsContext } from '../../internal/ModalsContext';
//@ts-expect-error: can't assume state generics at this point
const modalStateReducer = (state, action) => {
  switch (action.type) {
    case 'set':
      return [...state, action.payload];
    case 'reset':
      return state.filter(modal => modal.id !== action.payload.id);
    default:
      return state;
  }
};
export function ModalsProvider(_ref) {
  let {
    children
  } = _ref;
  const [modals, setModal] = useReducer(modalStateReducer, []);
  const isSyncedWithWindow = useRef(false);
  if (!isSyncedWithWindow.current && typeof window !== 'undefined') {
    window['@ui5/webcomponents-react'] ??= {};
    window['@ui5/webcomponents-react'].ModalsContext = ModalsContext;
    window['@ui5/webcomponents-react'].setModal = setModal;
    isSyncedWithWindow.current = true;
  }
  return /*#__PURE__*/React.createElement(ModalsContext.Provider, {
    value: {
      setModal
    }
  }, modals.map(modal => {
    if (modal?.Component) {
      return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(modal.Component, {
        ...modal.props,
        ref: modal.ref,
        key: modal.id,
        "data-id": modal.id
      }), modal.container ?? document.body);
    }
  }), children);
}